interface Details {
  currency?: string
  unconvertedAirlineFee?: { amount: number; currency: string }[]
}

export function missingSupplierFeeMessage(details: Details | null) {
  const fees = details?.unconvertedAirlineFee
  if (!fees) {
    return 'No supplier fee found, the booking is probably non-refundable. If not, correct the supplier fee in PD then proceed back.'
  }

  const airlineFee = fees.map(fee => `${fee.amount.toLocaleString('en-AU')} ${fee.currency}`).join(' + ')
  return (
    `No supplier fee found. The airline's cancellation fee is ${airlineFee}, not all in ${details.currency}, so it wasn't ` +
    `filled in automatically. Check the fare rules, add the supplier fee in ${details.currency} in PD, then proceed back.`
  )
}
